import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { useSiteConfig } from '../context/SiteConfigContext';

/**
 * Bannière promotionnelle gérée depuis le dashboard admin.
 * S'affiche en haut de toutes les pages quand activée.
 */
const PromoBanner = () => {
  const { config } = useSiteConfig();
  const enabled = config['home.banner.enabled'];
  const text = config['home.banner.text'];
  const url = config['home.banner.url'];

  if (!enabled || !text) return null;

  const inner = (
    <div className="flex items-center justify-center gap-2 text-sm text-white">
      <Megaphone className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{text}</span>
    </div>
  );

  return (
    <div className="bg-[#C75B27] py-2 px-4" data-testid="promo-banner">
      {url ? (
        <Link to={url} className="block hover:underline max-w-7xl mx-auto">{inner}</Link>
      ) : (
        <div className="max-w-7xl mx-auto">{inner}</div>
      )}
    </div>
  );
};

export default PromoBanner;
